import { render, staticRenderFns } from "./BarEcharts1.vue?vue&type=template&id=1fb064ca"
import script from "./BarEcharts1.vue?vue&type=script&lang=js"
export * from "./BarEcharts1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports